// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__1FzV3","button":"TextInput_button__2eNy9"};